import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../../_common/button';

export function QuantityInput({
  className,
  value,
  onQuantityChange,
  min,
  max,
  id,
  hideLabel,
}) {
  const inputId = `${id}-input`;
  const [internalValue, setInternalValue] = useState(value);
  const handleInputChange = e => {
    setInternalValue(
      Number.isNaN(e.target.valueAsNumber) ? '' : e.target.valueAsNumber
    );
  };
  const handleQuantityUpdate = useCallback(
    quantityValue => {
      const quantityNumber = Number(quantityValue);
      const numberValid =
        !Number.isNaN(quantityNumber) &&
        quantityNumber >= min &&
        quantityNumber <= max;

      if (numberValid) {
        setInternalValue(quantityNumber);
        onQuantityChange(quantityNumber);
      } else {
        setInternalValue(value); // reset when not valid
      }
    },
    [onQuantityChange, min, max, value]
  );
  const handleKeyDown = event => {
    if (event.keyCode === 27) {
      // reset on Escape key, unfocus rather than blur() so we dont trigger onBlur
      document.body.focus();
      setInternalValue(value);
    } else if (event.key === 'Enter') {
      event.target.blur(); // accept the current value on Enter key
    }
  };

  return (
    <div
      id={id}
      className={classNames('input-group quantity-input-group', className)}>
      <div className="input-group-prepend">
        <Button
          className="btn-secondary btn-minus"
          aria-label="Decrease quantity of prints by 1"
          disabled={value - 1 < min}
          onClick={() => handleQuantityUpdate(value - 1)}
          text="Less"
          icon="fa-minus fa-fw"
          hideLabel
        />
      </div>
      <input
        type="number"
        className="form-control"
        id={inputId}
        min={min}
        max={max}
        step="1"
        value={internalValue}
        onChange={handleInputChange}
        onBlur={() => handleQuantityUpdate(internalValue)}
        onKeyDown={handleKeyDown}
      />
      <div className="input-group-append">
        <Button
          className="btn-secondary btn-plus"
          aria-label="Increase quantity of prints by 1"
          disabled={value + 1 > max}
          onClick={() => handleQuantityUpdate(value + 1)}
          text="More"
          icon="fa-plus fa-fw"
          hideLabel
        />
      </div>
      <label
        htmlFor={inputId}
        className={classNames('w-100 text-center mb-0', {
          'sr-only': hideLabel,
        })}>
        Quantity
      </label>
    </div>
  );
}

QuantityInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  id: PropTypes.string,
};

QuantityInput.defaultProps = {
  min: 1,
  max: 999,
  id: 'prints-builder-photo-quantity',
  hideLabel: false,
};
